import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import ptBR from './locales/pt-BR.json';

function getSavedLocale() {
  try {
    return localStorage.getItem('locale');
  } catch (e) {
    return null;
  }
}

function getUrlLocale() {
  try {
    const params = new URLSearchParams(window.location.search);
    return params.get('lang');
  } catch (e) {
    return null;
  }
}

function pickFromBrowser(supported = ['en', 'pt-BR']) {
  const prefs = navigator.languages || [navigator.language || navigator.userLanguage];
  for (const lang of prefs) {
    const norm = (lang || '').toLowerCase();
    if (supported.map(s => s.toLowerCase()).includes(norm)) return lang;
    if (norm.startsWith('pt')) return 'pt-BR';
    if (norm.startsWith('en')) return 'en';
  }
  return 'pt-BR';
}

export const i18n = createI18n({
  legacy: false,
  locale: getUrlLocale() || getSavedLocale() || pickFromBrowser(),
  fallbackLocale: 'en',
  messages: { en, 'pt-BR': ptBR },
});

export function setLocale(locale) {
  i18n.global.locale.value = locale;
  try {
    localStorage.setItem('locale', locale);
  } catch (e) {
    // localStorage may be unavailable (e.g., private mode / SSR); ignore persist failure
    void e;
  }
}


